import styled from "styled-components";

export const Handle = styled.div((props) => ({
  borderBottom: "0 solid transparent",
  borderRight: "15px solid black",
  borderTop: "15px solid transparent",
  bottom: "70%",
  cursor: props.cursor,
  display: "inline-block",
  height: 0,
  position: "absolute",
  right: 0,
  width: 0,
}));

export const Resizable = styled.div({
  position: "relative",
  width: "50%",
  // borderRight: "1px solid black",
  // maxWidth:"80%",
  // minWidth:"20%"
});
